<template>
  <div class="container-fluid h-100">
    <div class="row justify-content-center align-items-center h-100">
        <div class="col col-sm-6 col-md-6 col-lg-4 col-xl-3 pt-5">
          <card>
            <img class="img-fluid" src="img/breaze-black-logo.png" alt="">
            <h4 v-if="result" slot="header" class="card-title text-center">{{ result }}</h4>
            <form>
              <div class="row">
                <div class="col-md-12">
                  <base-input type="text"
                            label="Email Address"
                            placeholder="Email Address"
                            v-model="emailAddress">
                  </base-input>
                </div>
              </div>
              <div class="text-center mb-1">
                <button type="submit" class="btn btn-fill" @click.prevent="forgotPassword" :disabled="!emailAddress">
                  Submit
                </button>
              </div>
              <div class="text-center">
                <a href="/#/login">Back To Login</a>
              </div>
              <div class="clearfix"></div>
            </form>
          </card>
        </div>
      </div>
  </div>
</template>
<script>
  import { getAuth, sendPasswordResetEmail } from "firebase/auth";

  import Card from 'src/components/Cards/Card.vue'

  export default {
    components: {
      Card
    },
    data () {
      return {
        emailAddress: '',
        result: ''
      }
    },
    methods: {
      async forgotPassword() {
        try {
          const auth = getAuth();
          await sendPasswordResetEmail(auth, this.emailAddress)
          this.result = 'Password Reset Sent To Your Email!'
        } catch (error) {
          console.error('forgotPasswordError', error)
          this.result = error
        }
      }
    }
  }

</script>
<style>

</style>
